
 
import { usePosition } from '../../custom_hooks/usePosition';
import moment from 'moment'
import { React, useEffect, useState, Fragment, useCallback, useRef, useMemo } from "react";

import cogoToast from "cogo-toast";
import { SUCCESS_RESULT, TEMPLATES_URL, ENDPOINTS, LOCAL_PARAMS } from "../../Constants";
import { getTemplateByName, genericPost, genericGet } from "../../services/Api";
import { EbmsLoading, localizeData, getLocalizeData, resetLocalizeData, isObjectEmpty, log, getUniqueString } from "../../services/Utils";

import { Spinner } from "reactstrap";
import { useHistory, Link, useParams } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Table, Button } from "reactstrap";
// import * as d3 from "d3";
import "./style.css";
import * as FaIcons from 'react-icons/fa';
import * as SurveyCore from "survey-core";
// import { Survey } from 'survey-react-ui';
import * as Survey from "survey-react";

import "survey-core/defaultV2.css";
import "survey-creator-core/survey-creator-core.min.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { FileSaver, saveAs } from 'file-saver';
import * as Alerts from '../customs/Alerts'
SurveyCore.StylesManager.applyTheme("defaultV2");
const WebSurveys = () => {
    const [isLoading, setIsLoading] = useState(false);
    // const [user, setUser] = useState({});
    const [surveyModel, setSurveyModel] = useState(new SurveyCore.Model({}));
    const [surveyDetails, setSurveyDetails] = useState({});
    const [surveyModelData, setSurveyModelData] = useState({});
    const params = useParams();
    let startedAt = moment(new Date(), 'YYYY-mm-D H:mm:ss');
    let surveyResponses = {};
    let syncToken= getUniqueString(32);

    // log("startedAt",startedAt)
    // let endedAt=moment(new Date(), 'YYYY-mm-D H:mm:ss');
    // log("User Data: ",params);
    const { latitude, longitude, error } = usePosition();
    // log("latitude",latitude);
    // log("longitude",longitude);
    // const submitSurveyResponses = (responses) => {
        const submitSurveyResponses = async (responses) => {


        if (isObjectEmpty(params, 'id') || !(surveyDetails["version"])) {
            cogoToast.error("Warning!! Invalid request. Check the link you are loading and try again.", {});
            return;
        }
        // log("startedAt", startedAt);
        let endedAt = moment(new Date(), 'YYYY-mm-D H:mm:ss');
        // log("endedAt", endedAt);

        let reqData = {
            "sync_token":syncToken,
            "token": params.id,
            "survey_responses": responses,
            "ip_address": JSON.stringify({}),
            "location": JSON.stringify({ "latitude": latitude, "longitude": longitude }),
            "version": surveyDetails["version"],
            "started_at": startedAt,
            "ended_at": endedAt
        };
        // log("reqData", reqData);
        setIsLoading(true);
        genericPost(ENDPOINTS.POST_WEB_SURVEY_RESPONSES, reqData)
            .then((res) => {
                if (res.status == 200) {
                    if (res.data.status == SUCCESS_RESULT) {
                        localStorage.setItem("SAVED_SURVEY","Survye-Done");
                        cogoToast.success(res.data.message, {});
                    } else {
                        cogoToast.error(res.data.message, {});
                    }
                } else {
                    cogoToast.error("Connection error. Please try again.", {});
                }
                setIsLoading(false);
            })
            .catch((err) => {
                setIsLoading(false);
                cogoToast.error("Critical error occurred. Please try again.", {});
            });
    };
    const loadSurvey = () => {
        if (isObjectEmpty(params, 'id')) {
            cogoToast.error("Warning!! Invalid request. Check the link you are loading and try again.", {});
            return;
        }
        setIsLoading(true);
        genericPost(ENDPOINTS.LOAD_WEB_SURVEY_DETAILS, { "token": params.id })
            .then((res) => {
                if (res.status == 200) {
                    if (res.data.status == SUCCESS_RESULT) {
                        let rawData = res.data;
                        // log("RawData: ", rawData);
                        if (!rawData['data']) {
                            cogoToast.error("You request was not successful. Please try again Please try again.", {});
                            setIsLoading(false);
                            return;
                        } else {
                            let surveyDetails = rawData.data;
                            // log("Response: ",surveyDetails);
                            // if (surveyDetails['name'])
                            document.title = surveyDetails['name'];
                            setSurveyDetails(surveyDetails);
                            setSurveyModel(new SurveyCore.Model(surveyDetails['questionnaire']));
                        }

                    } else {
                        cogoToast.error(res.data.message, {});
                    }
                } else {
                    cogoToast.error("Connection error. Please try again.", {});
                }
                setIsLoading(false);
            })
            .catch((err) => {
                // log("Error:: ");
                // log(err);
                setIsLoading(false);
                cogoToast.error("Critical error occurred. Please try again.", {});
            });
    };

    useEffect(() => {
        document.title = "Invited to complete your survey.";

        loadSurvey();
      
        // else
        //     document.title = "Invited to complete your survey.";
      
        // let _user = global.get_logged_in_user();
        // if (_user) {
        //     log("User Data: ",_user);
        //     setUser(_user);
        // } else {
        // }
    }, []);
    surveyModel.onValueChanged.add(function (survey, options) {
        setSurveyModelData(survey);
  });
  surveyModel.onCurrentPageChanged.add(function (survey, options) {
    setSurveyModelData(survey);
  });
    surveyModel.onComplete.add((sender, options) => {
        // console.log(JSON.stringify(sender.data, null, 3));
        cogoToast.error("handle submision.", {});
        surveyResponses = sender.data;
        // setSurveyModelData(surveyResponses);
        // submitSurveyResponses(JSON.stringify(surveyResponses))
        return ;
    });
    surveyModel.showNavigationButtons = false;

    const surveyCss = {
        actionBar: {
            root: "sd-action-bar custom-actionbar-root",
        },
        navigation: {
            complete: "sd-btn--action sd-navigation__complete-btn custom-btn btn-info",
            prev: "sd-navigation__prev-btn custom-btn",
            next: "sd-navigation__next-btn custom-btn",
            start: "sd-navigation__start-btn custom-btn",
            preview: "sd-navigation__preview-btn custom-btn",
        },


    }
    if (error && 1==3)
        return (
            <div style={{ marginRight: "10px", marginLeft: "10px" }} className="row">
                <center>                <div class="pull-center">
                    <h3 style={{ color: "#ff0000" }}>{error}</h3>
                </div>
                </center>
            </div>
        );
    else
        return (
            <div>
                {/* <Breadcrumb style={{ backgroundColor: '#ffffff' }} className="ms-1 p-2">
                <BreadcrumbItem>
                    <Link to="/ebms"> EBMS </Link>
                </BreadcrumbItem>
                <BreadcrumbItem >
                    <Link to="/surveys"> SURVEYS </Link>
                </BreadcrumbItem> 

            </Breadcrumb> */}
                <div style={{ marginRight: "10px", marginLeft: "10px" }} className="row">
                    <center><EbmsLoading data={isLoading} /></center>
                    <div style={{ margin: "20px", backgroundColor: "#ffffff" }} class="pull-center">
                    <Survey.Survey model={surveyModel} />
                        {/* <Survey style="backgroundColor:#ffffff" css={surveyCss} model={surveyModel}
                        data={surveyModelData}
                         
                      onComplete=(form_result)=>{
                        let payload = form_result.valuesHash;
                      }
                        
                           

                        /> */}
                        <center>   <Button disabled={(localStorage.getItem("SAVED_SURVEY",null)!==null)}
          className="btn btn-info pull-right"
          onClick={() => {
            
            surveyResponses = surveyModel.data;
            
            setSurveyModelData(surveyResponses);
            submitSurveyResponses(JSON.stringify(surveyResponses));
            surveyModel.doComplete();
           
          }}
        >
          SUBMIT YOUR SURVEY RESPONSES
        </Button></center>
                    </div>
                </div>
            </div>
        );
};

export default WebSurveys;